import { render, staticRenderFns } from "./fcwpFooter.vue?vue&type=template&id=21828ddc&"
import script from "./fcwpFooter.vue?vue&type=script&lang=js&"
export * from "./fcwpFooter.vue?vue&type=script&lang=js&"
import style0 from "./fcwpFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports